module.exports = __webpack_public_path__ + "static/media/unicef-logo.cd37730b.svg";